"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M16.647 26.889a7.858 7.858 0 0 0-6.01 2.188 14.07 14.07 0 0 0-2.967 5.879c-.875 2.783-1.7 5.41-5.261 7.107a1 1 0 0 0 .264 1.89c.8.136 1.72.252 2.72.326 3.6.268 10.38.154 15.315-3.6a7.605 7.605 0 0 0 3.139-5.563 7.739 7.739 0 0 0-7.2-8.227zM26.53 30.1C36.51 18.977 47.871 5.715 45.094 2.938S29.335 13.15 19.48 23.8a11.4 11.4 0 0 1 7.05 6.3z" })
);

